import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const StudentInformationItem = (props) => {
    const [data, setData] = useState([]);
    const [visiblePasswords, setVisiblePasswords] = useState([]);

    // Sync data from props
    useEffect(() => {
        setData(props.data || []);
    }, [props.data]);

    // Re-initialize visibility state whenever `data` changes
    useEffect(() => {
        setVisiblePasswords(data.map(() => false));
    }, [data]);

    // Toggle visibility for a specific row
    const toggleVisibility = (index) => {
        setVisiblePasswords((prev) =>
            prev.map((visible, i) => (i === index ? !visible : visible))
        );
    };

    return (
        <>
            <div>
                <div>
                    <div>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th>S No.</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Password</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.length > 0 && data?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(props.filterpage - 1) * props.filterlimit + (index + 1)}</td>
                                        <td>{item?.student_name}</td>
                                        <td>{item?.student_email}</td>
                                        {/* <td>{item.password}</td> */}
                                        <td>{visiblePasswords[index] ? item?.student_password : '••••••'}</td>
                                        <td>
                                            {/* Toggle the password visibility */}
                                            <span
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => toggleVisibility(index)}
                                            >
                                                {visiblePasswords[index] ? <VisibilityOff /> : <Visibility />}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </>

    );
};
export default StudentInformationItem;